(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function () {
    const MOBILE_QUERY = '(max-width: 749px)';

    function isMobile() {
      return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
    }

    function getIconSectionCandidates() {
      return Array.from(document.querySelectorAll('.section-wrapper')).filter((wrapper) => {
        const content = wrapper.querySelector('.section-content-wrapper');
        if (!content) return false;

        // Get direct children that are group-block
        const slides = Array.from(content.children).filter(el => el.classList.contains('group-block'));
        
        // Need at least 1 slide with icon
        if (slides.length < 1) return false;

        // Check if at least one has an icon-block
        return slides.some((slide) => slide.querySelector('.icon-block'));
      });
    }

    function setupIconSection(wrapper) {
      if (wrapper.dataset.iconSectionInitialized === 'true') return;

      const content = wrapper.querySelector('.section-content-wrapper');
      if (!content) return;

      // Get direct children only
      const slides = Array.from(content.children).filter(el => el.classList.contains('group-block'));
      
      if (slides.length < 1) return;

      wrapper.classList.add('js-icon-section');
      wrapper.dataset.iconSectionInitialized = 'true';

      console.log('Icon section found with', slides.length, 'slides');

      // Mobile carousel with dots
      if (isMobile() && slides.length > 1) {
        setupMobileCarousel(wrapper, content, slides);
      }
    }

    function setupMobileCarousel(wrapper, content, slides) {
      const dotsContainer = wrapper.querySelector('[data-icon-carousel-dots]');
      if (!dotsContainer) return;

      // Show dots container
      dotsContainer.removeAttribute('hidden');

      // Clear existing dots
      dotsContainer.innerHTML = '';

      console.log('Creating', slides.length, 'dots');

      // Create a dot for EACH slide
      slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
        dot.dataset.index = i;

        dot.addEventListener('click', () => {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });

        dotsContainer.appendChild(dot);
      });

      const dots = Array.from(dotsContainer.querySelectorAll('.carousel-dot'));

      // Update active dot on scroll
      let scrollTimeout;
      content.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const containerRect = content.getBoundingClientRect();
          const containerCenter = containerRect.left + containerRect.width / 2;
          
          let closestIndex = 0;
          let closestDistance = Infinity;
          
          slides.forEach((slide, i) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter = slideRect.left + slideRect.width / 2;
            const distance = Math.abs(containerCenter - slideCenter);
            
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = i;
            }
          });

          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === closestIndex);
          });
        }, 50);
      });

      // Ensure first slide is visible
      content.scrollLeft = 0;
    }

    function initAll() {
      getIconSectionCandidates().forEach(setupIconSection);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:reorder', initAll);
    document.addEventListener('shopify:section:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
